import { render, staticRenderFns } from "./base-selete.vue?vue&type=template&id=9c7185d0&scoped=true&"
import script from "./base-selete.vue?vue&type=script&lang=js&"
export * from "./base-selete.vue?vue&type=script&lang=js&"
import style0 from "./base-selete.vue?vue&type=style&index=0&id=9c7185d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7185d0",
  null
  
)

export default component.exports